export default __webpack_public_path__ + "static/media/open-sea-logo.16e51339.png";